import { createIcon } from '@chakra-ui/react'

export const ChevronDownIcon = createIcon({
  displayName: 'ChevronDownIcon',
  viewBox: '0 0 16 17',
  path: (
    <path d='M4 6.21582L8 10.2158L12 6.21582' stroke='currentColor' fill='none' strokeWidth='1.75' strokeLinecap='round' strokeLinejoin='round' />
  ),
})
